import { Box, Button, Group, Paper, Select, Text } from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import FileList from "./fileList";
import { isWidgetReadOnly } from "../helpers/formReadOnly";
import { OTHER_CERTIFICATE_OPTIONS } from "../data/otherCertificates";

const OtherCertificateList = ({
  form,
  name,
  readOnly = false,
  disabled = false,
  readonly = false,
}) => {
  const { t } = useTranslation();
  const locked = isWidgetReadOnly({ disabled, readOnly, readonly, form });
  const rows = _.get(form?.values, name) || [];

  const saveRows = async (next) => {
    const cleaned = next.map((row) => {
      const copy = { ...row };
      if (!copy.type) delete copy.type;
      if (!Array.isArray(copy.files)) copy.files = [];
      return copy;
    });
    form.setFieldValue(name, cleaned);
    const recordId = form?.values?._id;
    if (recordId && typeof form.savePartialFields === "function") {
      await form.savePartialFields({ [name]: cleaned });
    }
  };

  const updateRow = async (index, patch) => {
    const current = _.cloneDeep(_.get(form.values, name) || []);
    current[index] = { ...(current[index] || {}), ...patch };
    await saveRows(current);
  };

  return (
    <Box>
      {rows.length === 0 ? (
        <Text size="sm" color="dimmed" mb="sm">
          {t("No other certificates yet")}
        </Text>
      ) : (
        rows.map((row, index) => (
          <Paper key={row._id || index} withBorder p="md" mb="sm" radius="sm">
            <Group position="apart" align="flex-start" noWrap>
              <Select
                sx={{ flex: 1 }}
                label={t("Certificate type")}
                placeholder={t("Select certificate")}
                data={OTHER_CERTIFICATE_OPTIONS}
                value={row.type || null}
                onChange={(value) => updateRow(index, { type: value })}
                disabled={locked}
                clearable={!locked}
                withinPortal
              />
              {!locked && (
                <Button
                  mt={24}
                  variant="subtle"
                  color="red"
                  size="xs"
                  leftIcon={<IconTrash size={14} />}
                  onClick={() =>
                    saveRows(rows.filter((_, rowIndex) => rowIndex !== index))
                  }
                >
                  {t("Remove")}
                </Button>
              )}
            </Group>
            <Box mt="sm">
              <FileList
                compact
                form={form}
                name={`${name}.${index}.files`}
                disabled={locked}
                uploadLabel="Drop PDF or image, or click to browse"
                showNoFilesMessage={false}
              />
            </Box>
          </Paper>
        ))
      )}
      {!locked && (
        <Button
          variant="filled"
          size="xs"
          leftIcon={<IconPlus size={14} />}
          onClick={() => saveRows([...(rows || []), { files: [] }])}
        >
          {t("Add certificate")}
        </Button>
      )}
    </Box>
  );
};

export default OtherCertificateList;
